import * as API from './../base/api_service';
import * as serviceCallConfig from './../config/api_urls';

export var GET_SECURE_REASON = 'GET_SECURE_REASON';
export var PUT_SECURE_REASON = 'PUT_SECURE_REASON';
export var LOGS_LIST = 'LOGS_LIST';
export var POST_LOG = 'POST_LOG';
export var REDFLAGS_HISTORY = 'REDFLAGS_HISTORY';
export var REDFLAG_ACTION = 'REDFLAG_ACTION';

export var get_reasons = (data) => ({
    type: GET_SECURE_REASON,
    data: data
});

export var getReasons = () => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.GET_SECURE_REASON),//endPoint
            // serviceCallConfig.get(serviceCallConfig.GET_SECURE_REASON ) + '/' + (id) + '/' + (reasonId),//endPoint
            '',//payLoad
            serviceCallConfig.GET_SECURE_REASON,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            // "",
            "",//api_key
            // data,//getParams
            "",
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

export var put_response = (data) => ({
    type: PUT_SECURE_REASON,
    data: data
});



export var updateReason = (id, reasonId, reason, payload) => {
    console.log(id, 'iddd')
    console.log(reasonId, 'responseidd')
    console.log(reason);
    return (dispatch, getState) => {
        API.makeServiceCall(
            id === 0 ? serviceCallConfig.API_POST : serviceCallConfig.API_PUT,//reqType
            dispatch,//dispatch
            (serviceCallConfig.get(serviceCallConfig.PUT_SECURE_REASON)) + '/' + (getState().User.loginData.data.id) +
            (id !== 0 ? ('/flags/' + (id) + '/' + ('resolve/') + (reasonId) + (reason ? ('?otherReason=' + reason) : '')) :
                ('/flag/resolveAll/' + getState().Facilites.FaciliteAdminUser.data.id + '/' +
                    getState().Facilites.FaciliteAdminUser.data.facilities[0].facility.id)),//endPoint
            // PUT - /api/v1/secure/patients/flags/resolve/{id}/{reasonId}
            id === 0 ? payload : '',//payLoad
            serviceCallConfig.PUT_SECURE_REASON,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            // data,//getParams
            '',
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };

};

export var getLogsList = (data) => ({
    type: LOGS_LIST,
    data: data
});

export let getLogs = (id) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.GET_LOGS) + '/' + (id) + '/reasons',//endPoint
            '',//payLoad
            serviceCallConfig.LOGS_LIST,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            // data,//getParams
            '',
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
}

export let postLogsResponse = (data) => ({
    type: POST_LOG,
    data: data
});

export let postLogs = (id, logData, payload) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            (serviceCallConfig.get(serviceCallConfig.POST_LOG)) + (getState().User.loginData.data.id) + (id === 0 ?
                ('/flag/addnotes/' + getState().Facilites.FaciliteAdminUser.data.id + '/' +
                    getState().Facilites.FaciliteAdminUser.data.facilities[0].facility.id)
                : ('/flags/' + (id) + '/unresolve?reason=' + logData)),//endPoint
            id === 0 ? payload : '',//payLoad
            serviceCallConfig.POST_LOG,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            // data,//getParams
            '',
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
}

//RED FLAGS HISTORY
export var getResolvedRedFlagsHistory = (data) => ({
    type: REDFLAGS_HISTORY,
    data: data
});

export let getHistory = (id) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.HISTORY_LOGS) + '/' + (id) + '/actions',//endPoint
            '',//payLoad
            serviceCallConfig.HISTORY_LOGS,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            // data,//getParams
            '',
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
}


//GET RED FLAG ACTION BY ID
export var getRedFlagActionById = (data) => ({
    type: REDFLAG_ACTION,
    data: data
});

export let redFlagAction = (reasonId, flagId) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.RESOLVED_REDFLAG_ACTION) + '/' + (getState().User.loginData.data.id) + '/flags/' + (flagId) + '/resolve/' + (reasonId),//endPoint
            '',//payLoad
            serviceCallConfig.HISTORY_LOGS,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            // data,//getParams
            '',
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
}


/** WEBPACK FOOTER **
 ** ./src/actions/reason_actions.js
 **/